<template>
    <div class="text-center">
        <d-button class="btn btn-danger" @click="disconnect()">Disconnect</d-button>
    </div>
</template>

<script>
    import {ErrorService, WebsiteService} from '@/main';
    import notification from '@/mixins/notification';
    import * as Sentry from "@sentry/browser"

    export default {
        name: "KeuzeNLConnectForm",

        props: ['websiteId'],

        mixins: [notification],

        methods: {
            async disconnect() {
                try {
                    await WebsiteService.disconnectIntegration(this.$route.params.id, 'knl')

                    this.showNotification('success', 'Alert', 'Keuze.NL successfully disconnected!')
                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            },
        },
    }
</script>
